import { BULK_SCENARIO_GROUP_REQUEST,
         BULK_SCENARIO_GROUP_SUCCESS,
         BULK_SCENARIO_GROUP_ERROR,
         BULK_SCENARIO_GROUP_UPDATE_TASK } from '../../constants/bulkScenarioGroup/bulkScenarioGroupConstants';

const INITIAL_STATE = {
    tasks: { },
    columns: {
        'column-1': {
            id: 'column-1',
            title: 'Scenario',
            taskIds: []
        },
        'column-2': {
            id: 'column-2',
            title: 'Scenario Group',
            taskIds: [],
        }
    },
    columnOrder: ['column-1', 'column-2'],
}

export const bulkScenarioGroupReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case BULK_SCENARIO_GROUP_REQUEST:
            return {
                loading: true,
                info: {
                    ...INITIAL_STATE
                },
            }

        case BULK_SCENARIO_GROUP_SUCCESS:
            const columns = {
                'column-1': {
                    id: 'column-1',
                    title: 'Scenario',
                    taskIds: Object.keys(action.payload),
                },
                'column-2': {
                    id: 'column-2',
                    title: 'Scenario Group',
                    taskIds: [],
                }
            }
            return {
                loading: false,
                info: {
                    ...INITIAL_STATE,
                    tasks: action.payload,
                    columns
                },
            }

        case BULK_SCENARIO_GROUP_ERROR:
            return {
                loading: false,
                error: action.payload,
            }

        case BULK_SCENARIO_GROUP_UPDATE_TASK:
            return {
                ...state,
                info: action.payload,
            }

        default:
            return state;
    }
}